module.exports = __webpack_public_path__ + "img/text-error-missing-answer.3c31131.svg";